'use client';
import styles from './categories.module.scss';
import { MdArrowBackIos } from 'react-icons/md';
import { CategoryType, CategoryVolumeEnum, ThemeEnum } from 'types';
import { COLORS } from 'utilities';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'context';
import { AppLinkComp, CategoryBreadcrumbComp } from 'components';
import { catIconData } from 'data/categoryIcon';
import { PATH } from 'data/path';
import { TbArrowRight, TbSearch } from 'react-icons/tb';
import { useRouterState } from 'scripts';
import { Empty, Input } from 'antd';
import { useSearchParams } from 'next/navigation';

function CategoriesComp(props: { categories: CategoryType<'list'>[] }) {
    // const bulkText = 'عمده فروشی';
    const { theme } = useContext(GlobalContext);
    const [selectedCategory, setSelectedCategory] = useState<CategoryType<'list'>>();
    const [mode, setMode] = useState<'single' | 'bulk'>('single');
    const [search, setSearch] = useState('');
    const searchParams = useSearchParams();

    useEffect(() => {
        if (!searchParams.get('cat') && selectedCategory) setSelectedCategory(undefined);
    }, [searchParams]);

    const backHandler = () => {
        if (selectedCategory) {
            const parent = props.categories.find((i) => i.id === selectedCategory.parent);
            setSelectedCategory(parent);
        } else if (mode === 'bulk') setMode('single');
    };
    const router = useRouterState(backHandler);

    const getParents = (list: CategoryType<'list'>[], category?: CategoryType<'list'>) => {
        if (!category || !category.parent) return list;
        const parentCat = props.categories.find((i) => i.id === category.parent);
        if (parentCat) return getParents([parentCat, ...list], parentCat);
        else return list;
    };

    // search categories, sort by title, then by bread crumb length
    const searchedCategories = props.categories
        .filter((i) => (search.length ? i.title.includes(search) : false))
        .sort((a, b) => a.title.localeCompare(b.title))
        .sort((a, b) => getParents([a], a).length - getParents([b], b).length);

    // const onBulkClick = () => {
    //     setSearch('');
    //     setMode('bulk');
    //     const url = new URL(window.location.href);
    //     url.searchParams.set('mode', 'bulk');
    //     window.history.pushState({}, '', url.href);
    // };

    const categoryCard = (title: string, icon?: string) => {
        const Icon = catIconData.find((i) => i.key === icon);
        return (
            <div className={`${styles['categories-card']} d-flex center-content-y justify-content-between pointer`}>
                <div className="d-flex center-content-y g-1">
                    {Icon ? <Icon.icon size={20} className="t-primary" /> : null}
                    <p className="t-400 t-p2 t-l-black1">{title}</p>
                </div>
                <MdArrowBackIos size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
            </div>
        );
    };

    const onCategorySelect = (category: CategoryType<'list'>) => {
        setSearch('');
        setMode(category.volume === CategoryVolumeEnum.multi ? 'bulk' : 'single');
        setSelectedCategory(category);
        const url = new URL(window.location.href);
        url.searchParams.set('cat', category.id.toString());
        if (category.volume === CategoryVolumeEnum.multi) url.searchParams.set('mode', 'bulk');
        window.history.pushState({}, '', url.href);
    };

    return (
        <div className={`flex-column g-2 ${styles['categories-container']}`}>
            <Input
                placeholder="جستجو در همه دسته ها"
                className={`${styles['search-container']}`}
                allowClear
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => setSearch('')}
                value={search}
                prefix={
                    <TbSearch
                        size={28}
                        className={`pl-1 pointer ${theme === ThemeEnum.light ? 't-black1' : 't-gray2'}`}
                    />
                }
            />
            {selectedCategory ? (
                <div className={`${styles['categories-back']} d-flex center-content-y pointer`} onClick={router.back}>
                    <TbArrowRight size={20} />
                    <p className="t-400 t-p2 t-l-black1">{selectedCategory.title}</p>
                </div>
            ) : null}
            {/* {(!search.length || bulkText.includes(search)) && mode === 'bulk' && !selectedCategory ? (
                <div className={`${styles['categories-back']} d-flex center-content-y pointer`} onClick={router.back}>
                    <TbArrowRight size={20} />
                    <p className="t-400 t-p2 t-l-black1">{bulkText}</p>
                </div>
            ) : null} */}
            {/* {(!search.length || bulkText.includes(search)) && !selectedCategory && mode === 'single' ? (
                <div className={styles['categories-link']} onClick={onBulkClick}>
                    <div
                        className={`${styles['categories-card']} d-flex center-content-y justify-content-between pointer`}
                    >
                        <div className="d-flex center-content-y g-1">
                            <TbCategory size={20} className="t-primary" />
                            <p className="t-400 t-p2 t-l-black1">{bulkText}</p>
                        </div>
                        <MdArrowBackIos size={16} color={theme === ThemeEnum.light ? COLORS.black1 : COLORS.gray3} />
                    </div>
                </div>
            ) : null} */}
            {search.length ? (
                searchedCategories?.length ? (
                    <div className={`${styles['categories-link']} flex-column g-2`}>
                        {search.length
                            ? searchedCategories.map((i) => (
                                  <CategoryBreadcrumbComp
                                      list={getParents([i], i)}
                                      key={i.id}
                                      onClick={onCategorySelect}
                                  />
                              ))
                            : null}
                    </div>
                ) : (
                    <Empty
                        className="flex-column center-content"
                        description="دسته ای با عبارت مورد نظر شما یافت نشد."
                    />
                )
            ) : null}
            {!search.length
                ? props.categories
                      .filter((i) =>
                          mode === 'single'
                              ? i.volume !== CategoryVolumeEnum.multi
                              : i.volume !== CategoryVolumeEnum.single,
                      )
                      .filter((i) => (selectedCategory ? i.parent === selectedCategory.id : !i.parent))
                      .sort((a, b) => (b.order ?? 0) - (a.order ?? 0))
                      .map((category) =>
                          props.categories.find((i) => i.parent === category.id) ? (
                              <div
                                  key={category.id}
                                  className={styles['categories-link']}
                                  onClick={() => {
                                      setSelectedCategory(category);
                                      router.push(window.location.href + '?cat=' + category.id);
                                  }}
                              >
                                  {categoryCard(category.title, category.icon)}
                              </div>
                          ) : (
                              <AppLinkComp
                                  key={category.id}
                                  href={PATH.posts({ category: category })}
                                  className={styles['categories-link']}
                              >
                                  {categoryCard(category.title, category.icon)}
                              </AppLinkComp>
                          ),
                      )
                : null}
            {selectedCategory ? (
                <AppLinkComp href={PATH.posts({ category: selectedCategory })} className={styles['categories-link']}>
                    {categoryCard('مشاهده تمامی آگهی های ' + selectedCategory.title)}
                </AppLinkComp>
            ) : null}
        </div>
    );
}

export default CategoriesComp;
